import * as store from '@daas-consulting/core-frontend-store';
import * as models from '@daas-consulting/production/remitos/frontend/models';
import { context, feature } from '../remitos.const';

const getActions = store.getActionsNames({
  context,
  feature,
  section: store.SectionsNames.form,
  action: store.FormActionNames.getData,
});
const saveActions = store.getActionsNames({
  context,
  feature,
  section: store.SectionsNames.form,
  action: store.FormActionNames.save,
});
const getAvailablePrescriptionsActions = store.getActionsNames({
  context,
  feature,
  section: store.SectionsNames.form,
  action: 'Get available prescriptions',
});

const togglePrescriptionActionName = store.getActionName({
  context,
  feature,
  section: store.SectionsNames.form,
  action: 'Toggle prescription selection',
});

const toggleAllPrescriptionsActionName = store.getActionName({
  context,
  feature,
  section: store.SectionsNames.form,
  action: 'Toggle all prescriptions selection',
});

const assignLineActionName = store.getActionName({
  context,
  feature,
  section: store.SectionsNames.form,
  action: 'Assign line to prescription',
});

const setInstitutionActionName = store.getActionName({
  context,
  feature,
  section: store.SectionsNames.form,
  action: 'Set institution',
});

const setPurchaseOrderActionName = store.getActionName({
  context,
  feature,
  section: store.SectionsNames.form,
  action: 'Set purchase order',
});

const setLineActionName = store.getActionName({
  context,
  feature,
  section: store.SectionsNames.form,
  action: 'Set line',
});

const setPatientActionName = store.getActionName({
  context,
  feature,
  section: store.SectionsNames.form,
  action: 'Set patient',
});

const getActivePurchaseOrdersActions = store.getActionsNames({
  context,
  feature,
  section: store.SectionsNames.form,
  action: 'Get active purchase orders',
});

const addAdditionalArticleActionName = store.getActionName({
  context,
  feature,
  section: store.SectionsNames.form,
  action: 'Add additional article',
});

const removeAdditionalArticleActionName = store.getActionName({
  context,
  feature,
  section: store.SectionsNames.form,
  action: 'Remove additional article',
});

export class GetData {
  static readonly type = `${getActions.action}`;
}

export class GetDataRequest {
  static readonly type = `${getActions.request}`;
}

export class GetDataSuccessful {
  static readonly type = `${getActions.successful}`;
  constructor(readonly payload: models.FormData) {}
}

export class GetDataFailure {
  static readonly type = `${getActions.failure}`;
  constructor(readonly payload: Error) {}
}

export class Save {
  static readonly type = `${saveActions.action}`;
}

export class SaveRequest {
  static readonly type = `${saveActions.request}`;
}

export class SaveSuccessful {
  static readonly type = `${saveActions.successful}`;
}

export class SaveFailure {
  static readonly type = `${saveActions.failure}`;
  constructor(readonly payload: Error) {}
}

export class GetAvailablePrescriptions {
  static readonly type = `${getAvailablePrescriptionsActions.action}`;
  constructor(readonly payload: string) {} // institutionId
}

export class GetAvailablePrescriptionsRequest {
  static readonly type = `${getAvailablePrescriptionsActions.request}`;
}

export class GetAvailablePrescriptionsSuccessful {
  static readonly type = `${getAvailablePrescriptionsActions.successful}`;
  constructor(readonly payload: models.AvailablePrescriptionModel[]) {}
}

export class GetAvailablePrescriptionsFailure {
  static readonly type = `${getAvailablePrescriptionsActions.failure}`;
  constructor(readonly payload: Error) {}
}

export class TogglePrescriptionSelection {
  static readonly type = `${togglePrescriptionActionName}`;
  constructor(
    readonly payload: { prescriptionId: string; selected: boolean }
  ) {}
}

export class AssignLineToPrescription {
  static readonly type = `${assignLineActionName}`;
  constructor(readonly payload: { prescriptionId: string; lineId: string }) {}
}

export class SetInstitution {
  static readonly type = `${setInstitutionActionName}`;
  constructor(readonly payload: string) {} // institutionId
}

export class SetPurchaseOrder {
  static readonly type = `${setPurchaseOrderActionName}`;
  constructor(readonly payload: string) {} // purchaseOrderId
}

export class GetActivePurchaseOrders {
  static readonly type = `${getActivePurchaseOrdersActions.action}`;
  constructor(readonly payload: string) {} // institutionId
}

export class GetActivePurchaseOrdersRequest {
  static readonly type = `${getActivePurchaseOrdersActions.request}`;
}

export class GetActivePurchaseOrdersSuccessful {
  static readonly type = `${getActivePurchaseOrdersActions.successful}`;
  constructor(readonly payload: models.PurchaseOrderFormData[]) {}
}

export class GetActivePurchaseOrdersFailure {
  static readonly type = `${getActivePurchaseOrdersActions.failure}`;
  constructor(readonly payload: Error) {}
}

export class AddAdditionalArticle {
  static readonly type = `${addAdditionalArticleActionName}`;
  constructor(
    readonly payload: {
      articleId: string;
      quantity: number;
      lot: string | null;
      expirationDate: string | null;
    }
  ) {}
}

export class RemoveAdditionalArticle {
  static readonly type = `${removeAdditionalArticleActionName}`;
  constructor(
    readonly payload: {
      articleId: string;
      lot: string | null;
      expirationDate: string | null;
    }
  ) {}
}

export class SetLine {
  static readonly type = `${setLineActionName}`;
  constructor(readonly payload: string) {} // lineId
}

export class ToggleAllPrescriptionsSelection {
  static readonly type = `${toggleAllPrescriptionsActionName}`;
  constructor(readonly payload: { selected: boolean }) {}
}

export class SetPatient {
  static readonly type = `${setPatientActionName}`;
  constructor(readonly payload: string) {} // patientName
}
